import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import CustomizedBreadcrumbs from "../../components/Custom/CustomizedBreadcrumbs";
import CustomizedMenuList from "../../components/Custom/CustomizedMenuList";
import { IBreadcrumbsAndMenu } from "../../types/global";
import { useStateContext } from "../../contexts/auth-context";
import { hasPermission } from "../../utils/Global";

const Purchase = () => {
  const { t } = useTranslation();
  const {
    state: { permissions },
  } = useStateContext();

  const breadcrumbs: IBreadcrumbsAndMenu[] = [
    {
      name: t("purchase.index"),
    },
  ];

  const menuList: IBreadcrumbsAndMenu[] = [
    {
      name: t("purchase.request.index"),
      to: "/purchase/request",
      permissionKey: "purchase_request",
    },
    {
      name: t("purchase.order.index"),
      to: "/purchase/order",
      permissionKey: "purchase_order",
    },
    {
      name: t("purchase.return.index"),
      to: "/purchase/return",
      permissionKey: "purchase_return",
    },
    {
      name: t("report"),
      to: "/purchase/report",
      permissionKey: "purchase_report",
    },
  ].filter((item) => hasPermission(item.permissionKey, permissions));

  return (
    <Fragment>
      <CustomizedBreadcrumbs breadcrumbs={breadcrumbs} />
      <CustomizedMenuList menuList={menuList} />
    </Fragment>
  );
};

export default Purchase;
